import type { TPhase, TPhaseGroup } from 'types/classAndPhases'
import type { ToolkitVideosFilter } from 'types/toolkit'
import type { State } from 'zustand'
import create from 'zustand'
import { persist } from 'zustand/middleware'

export type TSavedSearcFilterStore = State & {
  modulBahanBukuSubject?: string
  modulProjekSubject?: string
  modulProjekThemeKey?: string
  phase?: TPhase[]
  phaseGroup?: TPhaseGroup
  title?: string
  videosFilter?: ToolkitVideosFilter[]
  setPhase?: (phase: TPhase[]) => void
  setPhaseGroup?: (phaseGroup: TPhaseGroup) => void
  setModulProjekSubject?: (subject: string) => void
  setModulProjekThemeKey?: (themeKey: string) => void
  setModulBahanBukuSubject?: (subject: string) => void
  setTitle?: (title: string) => void
  setVideosFilter?: (videosFilter: ToolkitVideosFilter[]) => void
}

const initialState: TSavedSearcFilterStore = {
  modulBahanBukuSubject: null,
  modulProjekSubject: null,
  modulProjekThemeKey: null,
  phase: null,
  phaseGroup: null,
  title: null,
  videosFilter: null,
}

export const useSavedSearchFilterStore = create<TSavedSearcFilterStore>(
  persist(
    (set) => ({
      ...initialState,
      setPhase: (phase) => set({ phase }),
      setPhaseGroup: (phaseGroup) => set({ phaseGroup }),
      setModulBahanBukuSubject: (subject) =>
        set({ modulBahanBukuSubject: subject }),
      setModulProjekSubject: (subject) => set({ modulProjekSubject: subject }),
      setModulProjekThemeKey: (themeKey) =>
        set({ modulProjekThemeKey: themeKey }),
      setTitle: (title) => set({ title }),
      setVideosFilter: (videosFilter) => set({ videosFilter }),
    }),
    {
      name: 'cur-fe-saved-search-filter',
      partialize: ({
        modulBahanBukuSubject,
        modulProjekSubject,
        modulProjekThemeKey,
        phase,
        phaseGroup,
        title,
        videosFilter,
      }) => ({
        modulBahanBukuSubject,
        modulProjekSubject,
        modulProjekThemeKey,
        phase,
        phaseGroup,
        title,
        videosFilter,
      }),
    }
  )
)
